export const GET_COMPANIES_LOADING = 'GET_COMPANIES_LOADING';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_ERROR = 'GET_COMPANIES_ERROR';
export const START_FETCHING_COMPANIES_WITH_USERS = 'START_FETCHING_COMPANIES_WITH_USERS';
export const GET_COMPANIES_WITH_USERS_SUCCESS = 'GET_COMPANIES_WITH_USERS_SUCCESS';
export const GET_COMPANIES_WITH_USERS_ERROR = 'GET_COMPANIES_WITH_USERS_ERROR';
